// 🚨 This is the global theme JavaScript code that can't or shouldn't be loaded JIT. This should remain as sparse as possible.
window.cpap.onDocumentReady(() => {
  // Adds the `is-visible` class to all reveal animation elements based on intersection observer visibility
  window.scheduler.postTask(
    () => {
      // Prevent child elements with the `.cpap__utility__prevent-parent-hyperlinking` class from initiating a native parent hyperlink event.
      window.cpap.preventParentHyperlinking();
    },
    { priority: 'user-blocking' }
  );

  /**
   * Adds scroll direction classes to the `section-header`, `sticky-sub-menu`, and `body` elements
   * based on the user's scroll direction (up or down).
   *
   * @function
   * @description
   * This function tracks the scroll position and dynamically applies CSS classes to indicate the scroll direction.
   * It uses the `scroll` event listener and applies classes like `cpap-scroll-to-top` and `cpap-scroll-to-down`
   * to elements such as `.section-header`, `.cpap__sticky-sub-menu`, and `body`.
   *
   * When scrolling up, it applies the `cpap-scroll-to-top` and `cpap-page-scroll-up` classes while removing the
   * downward scroll classes. When scrolling down, it applies `cpap-scroll-to-down` and `cpap-page-scroll-down`
   * while removing the upward scroll classes.
   *
   * @example
   * // Invoke the function to enable scroll direction detection
   * addGlobalScrollDirectionClasses();
   *
   * @remarks
   * The `megamenu-active` class on `.section-header` prevents upward scroll class changes while the megamenu is active.
   * The scroll event listener uses `window.throttle` to optimize performance by throttling the scroll handler.
   *
   * @see [Passive Event Listeners](https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#parameters)
   * for more information on the `passive` option used in the scroll event listener.
   */
  const addGlobalScrollDirectionClasses = () => {
    let previousScrollTop = 0;

    const sectionHeaderNode = document.querySelector('.section-header');
    const stickySubMenuNode = document.querySelector('.cpap__sticky-sub-menu');

    // We are on a page without sticky header
    if (!sectionHeaderNode || !stickySubMenuNode) {
      return;
    }

    const scrollDirectionClassEventListener = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (scrollTop < previousScrollTop) {
        // Up scrolling code
        sectionHeaderNode?.classList?.add('cpap-scroll-to-top');
        sectionHeaderNode?.classList?.remove('cpap-scroll-to-down');

        stickySubMenuNode?.classList.add('cpap-scroll-to-top');
        stickySubMenuNode?.classList.remove('cpap-scroll-to-down');

        document.body.classList.add('cpap-page-scroll-up');
        document.body.classList.remove('cpap-page-scroll-down');
      } else {
        // Down scrolling code
        if (!sectionHeaderNode.classList.contains('megamenu-active')) {
          sectionHeaderNode?.classList.remove('cpap-scroll-to-top');
          stickySubMenuNode?.classList.remove('cpap-scroll-to-top');
        }

        sectionHeaderNode?.classList.add('cpap-scroll-to-down');
        stickySubMenuNode?.classList.add('cpap-scroll-to-down');

        document.body.classList.add('cpap-page-scroll-down');
        document.body.classList.remove('cpap-page-scroll-up');
      }

      previousScrollTop = scrollTop;
    };

    document.addEventListener('scroll', window.cpap.throttle(scrollDirectionClassEventListener), {
      passive: true,
    });
  };

  window.scheduler.postTask(addGlobalScrollDirectionClasses, { priority: 'user-blocking' });

  //////////////////////
  // Vendor Overrides //
  //////////////////////
  // 👇 Gorgias App: https://www.gorgias.com/ecommerce/shopify
  (() => {
    const initGorgiasChatPromise = window.GorgiasChat
      ? window.GorgiasChat.init()
      : new Promise((resolve) =>
          window.addEventListener('gorgias-widget-loaded', resolve, { once: true })
        );

    // @see https://docs.gorgias.com/en-US/subscribe-to-chat-events-460530 for adding more Gorgias events
    initGorgiasChatPromise.then(() => {
      window.scheduler.postTask(
        () => {
          window.cpap.dynamicallyLoadStylesheet(window.cpap.cdnSources.gorgiasAppOverrideCss);
        },
        { priority: 'user-blocking' }
      );
    });
  })();

});
